<template>
  <section id="rekognition-event">
    <div class="row" v-if="faceDetection">
      <div class="col-xs-12 text-center">
        <img src="/rekognition.png" class="btn-rekognition" v-on:click="browse()" />
        <img ref="compatitorPreview" class='d-none'/>
        <input ref="fileName" type="file" class='d-none' v-on:change="preview()" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    event: null
  },
  data() {
    return {
      faceDetection: false
    }
  },
  watch: {
    event(value, oldVal) {
      this.faceDetection = value.face_detection
    }
  },
  methods:  {
    browse() {
      this.$refs.fileName.click()
    },
    preview() {
      const source = this.$refs.fileName
      const _this = this

      if(source.files && source.files[0]) {
        let reader = new FileReader()
        reader.onload = function (e) {
          _this.$refs.compatitorPreview.src = e.target.result
          _this.execute()
        }
        reader.readAsDataURL(source.files[0]);
      }
    },
    async execute() {
      try {
        this.$emit("setLoader", true)
        const response = await this.$http.post(
          `/api/v1/events/${this.event.identifier}/competitors/rekognition`,
          {
            competitor: {},
            image: this.$refs.compatitorPreview.src
          }
        )
        if(response && response.status === 200) {
          this.$root.$emit('addRekognitionPhotos', response.data.photos);
          this.$root.$emit('addRekognitionPhotosToAlbum', response.data.photos);
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss">
  #rekognition-event {
    img.btn-rekognition {
      cursor: pointer;
      width: 52px;
      margin-top: 3px;
    }
  }
</style>
